module.exports = __webpack_public_path__ + "static/media/7.question.72d8c5f4.mp4";